import { FEATURE_MIN_VOTES, FEATURE_VOTE_THRESHOLD } from '../data/features';
import { MIN_BARS_FOR_MAP_AREA_FILTER } from '../data/metros';
import { isBroaderMetroNeighborhood } from './barLocation';

export function isFeatureCommunityVerified(stat) {
  if (!stat || !stat.total) return false;
  return stat.total >= FEATURE_MIN_VOTES && (stat.yes / stat.total) >= FEATURE_VOTE_THRESHOLD;
}

export function barHasFeature(bar, featureKey, featureStats = {}) {
  if (!bar || !featureKey) return false;
  if (bar.attributes?.[featureKey] === true) return true;
  return isFeatureCommunityVerified(featureStats[featureKey]);
}

export function filterBarsByFeatures(bars, selectedFeatures = [], featureStatsByBar = {}) {
  if (!selectedFeatures.length) return bars;
  return bars.filter((bar) =>
    selectedFeatures.every((featureKey) =>
      barHasFeature(bar, featureKey, featureStatsByBar[bar.id] || {})
    )
  );
}

export function filterBarsByAreas(bars, selectedAreas = [], metro) {
  if (!selectedAreas.length) return bars;
  const allowed = new Set(selectedAreas);
  if (metro?.groups?.length) {
    selectedAreas.forEach((selected) => {
      const group = metro.groups.find((item) => item.name === selected);
      group?.areas?.forEach((area) => allowed.add(area));
    });
  }
  return bars.filter((bar) => allowed.has(bar.neighborhood));
}

export function getAreaFilterOptions(metroAreas = [], bars = [], metro) {
  const broader = [...new Set(
    bars.map((bar) => bar.neighborhood).filter(isBroaderMetroNeighborhood)
  )];

  if (metro?.groups?.length) {
    const boroughs = metro.groups.map((group) => group.name);
    return [...broader.filter((name) => !boroughs.includes(name)), ...boroughs];
  }

  const populated = [...new Set(
    bars
      .map((bar) => bar.neighborhood)
      .filter((name) => name && !isBroaderMetroNeighborhood(name))
  )].sort((a, b) => a.localeCompare(b));

  if (bars.length >= MIN_BARS_FOR_MAP_AREA_FILTER) {
    return [...broader, ...populated];
  }

  const catalog = [...new Set(
    metroAreas.filter((name) => name && !isBroaderMetroNeighborhood(name))
  )];
  const neighborhoods = [...new Set([...catalog, ...populated])]
    .sort((a, b) => a.localeCompare(b));

  return [...broader, ...neighborhoods];
}
